export enum FilesStatus {
  TO_REVIEW = "to_review",
  VALIDATED = "validated",
  UNREADABLE = "unreadable",
  EXPIRED = "expired",
  NON_COMPLIANT = "non_compliant",
}

export const FilesStatusTranslate: { [key in FilesStatus]: string } = {
  [FilesStatus.TO_REVIEW]: "to_review",
  [FilesStatus.VALIDATED]: "valide",
  [FilesStatus.UNREADABLE]: "illisible",
  [FilesStatus.EXPIRED]: "périmée",
  [FilesStatus.NON_COMPLIANT]: "non conforme",
}